import { render } from "./TrainingCertificateConfig.vue?vue&type=template&id=424e6626&ts=true"
import script from "./TrainingCertificateConfig.vue?vue&type=script&lang=ts"
export * from "./TrainingCertificateConfig.vue?vue&type=script&lang=ts"

import "./TrainingCertificateConfig.vue?vue&type=style&index=0&id=424e6626&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__